import { useState, useEffect } from "react";


function WebsiteCount() {
  const [visitCount, setVisitCount] = useState(null);

  useEffect(() => {
    const fetchVisit = async () => {
      const res = await fetch(`https://api.dramaqwizz.com/api/getWebsiteCount`);
      const data = await res.json();
      setVisitCount(data.websiteVisitCount || 0);
    };
    fetchVisit();
  }, []);

  useEffect(() => {
    if (visitCount === null) return;

    const trackVisit = async () => {
      if (!sessionStorage.getItem("VisitCount")) {
        sessionStorage.setItem("VisitCount", "YouVisitMywebsiteThankYou3000");
        const newCount = visitCount + 1;
        setVisitCount(newCount);
        await fetch(`https://api.dramaqwizz.com/api/setWebsiteCount`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ UserVisited: newCount }),
        });
      }
    };
    trackVisit();
  }, [visitCount]);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "yellow",
          marginTop: "100px",
          fontSize: "20px",
        }}
      >
        <div class="visit-container">
          <div class="visit-ribbon">
            <span class="star">✦</span>
            Website visit count: <span id="visit-number">{visitCount}</span>
            <span class="star">✦</span>
          </div>
        </div>
      </div>
    </>
  );
}
export default WebsiteCount;
